const InsightsComputationMixin = {
  props: {
    filter: Object | String,
    active: Boolean,
    nameS: String
  },

  data() {
    return {
      needRecalculation: true,
      insightComputationKey: 1
    };
  },

  mounted() {
    this.compute();
  },

  watch: {
    filter() {
      this.compute();
    },
    active() {
      this.compute(false);
    }
  },

  methods: {
    compute(reset=true) {
      this.insightComputationKey = this.insightComputationKey + 1;

      if (reset) {
        this.resetInsightsData();
        this.needRecalculation = true;
      }

      if (!this.active || !this.needRecalculation) return;
      this.needRecalculation = false;
      this.computeInsightsData();
    },

    resetInsightsData() {
      throw new Error("Not Implemented");
    },

    computeInsightsData() {
      throw new Error("Not Implemented");
    }
  }
};

export default InsightsComputationMixin;
